import React from "react";

import AnalyticsTracking from "Utils/AnalyticsTracking";

import { TitleSmall } from "Cobalt/Header";
import { StandaloneTrigger, Modal, ModalBody, ModalHeader, ModalFooter } from "Cobalt/Modal";
import Button from "Common/Button";

import CartEmployeePriceBreakdownBody from "./CartEmployeePriceBreakdownBody";

const CartEmployeePriceBreakdownModal = ({ plan, triggerText }) => (
  <StandaloneTrigger
    trigger={(props) => (
      <a
        href="#"
        {...props}
        onClick={(e) => {
          props.onClick(e);
          AnalyticsTracking.trackEvent("employee_costs_viewed", {
            location: "cart_page",
            plan,
          });
        }}
      >
        {triggerText || "View Cost Breakdown"}
      </a>
    )}
    modal={(props) => (
      <Modal {...props}>
        <ModalHeader closeButton>
          <TitleSmall mb={0} mt={0}>
            Explain This Price
          </TitleSmall>
        </ModalHeader>
        <ModalBody>
          <CartEmployeePriceBreakdownBody plan={plan} />
        </ModalBody>
        <ModalFooter>
          <Button key="close" onClick={() => props.onHide()}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    )}
  />
);

export default CartEmployeePriceBreakdownModal;
